export const PROTOCOL_TYPE = {
  OIDC: 'oidc',
  OAUTH: 'oauth'
};

export const SERVICE_TYPE = {
  SECOND_PARTY: 'second_party',
  THIRD_PARTY: 'third_party'
};
